import { oz } from '@weft/utils';
import { IntegrationConfigurationSchema } from './configuration';
import { IntegrationProvidersSchema } from './integration-providers-schema';
import { IntegrationTypesSchema } from './integration-types-schema';
import { OAuthDataSchema } from './oauth';

export const NewIntegrationSchema = oz.object({
  oAuthData: OAuthDataSchema,
  integrationType: IntegrationTypesSchema,
  integrationProvider: IntegrationProvidersSchema,
  integrationConfiguration: IntegrationConfigurationSchema,
}).openapi('NewIntegration');

export type NewIntegration = oz.infer<typeof NewIntegrationSchema>;
